<template>
            <div>
                <!--<input type='button' @click="getFoto" value='123'/>-->
            <iframe name='frame' style="display:none;"></iframe>
            <form method="POST" onsubmit="document.getElementById('loadform').style.display='none';document.getElementById('loadcirle').style.display='inline-block';" enctype="multipart/form-data" target='frame' :action="compAction">
            
            <div class='form-group row' id='loadform'>
                <div class='col-sm-6'>
                    <input type='file' name='foto' class='form-control' />
                </div>
                <input type='submit' class='btn btn-success' value='Загрузить' />
            </div>

            <i class="fas fa-circle-notch fa-spin" id='loadcirle' style="font-size:52px; display:none;"></i>
            </form>
            <div class='col-sm-12'>
                <h3>Загруженные фото</h3>
                <div v-for="(val,id) in json" :key="id">
                    <input type='button' class='btn btn-danger' value='Уалить' @click="delFoto(id);"/>
                        <div class='col-sm-12'>
                            <img :src="val"/>
                    </div>
                </div>    
            </div>
        </div>
</template>

<script>
import axios from 'axios';

export default {
    created: function(){
        this.getFoto();
    },
    methods:{
        delFoto: function(fotoid){
              axios({
                url: 'http://eduqa.egechita.ru/back/delfoto/'+fotoid,
                withCredentials: true,
                }).then((response) => {
                    this.getFoto();
                });
            },
        getFoto: function(){
            axios({
                url: 'http://eduqa.egechita.ru/back/getfoto/'+this.$route.params.id,
                withCredentials: true,
                }).then((response) => {
                    this.json = response.data;
                });
            }
    },
    computed: {
        compAction: function(){
            return "http://eduqa.egechita.ru/back/loadfoto/"+this.$route.params.id;
        }
    },
    data(){
        return {
            json: {}
        }
    }
}
</script>
